module.exports = __webpack_public_path__ + "static/media/专属投资工具@2x.e77f29d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/专属投资工具@2x.png
// module id = 1520
// module chunks = 0